var App = App || {};

App.OUPSeamlessAccess = (function ($) {
	return {
        init: init,
        updateButton: updateButton
	};

	function init() {
        saveShibbolethID();
        updateButton();
	}

	function saveShibbolethID() {
		const propertyName = 'SeamlessInstitution';
        const cookie = getCookieValue(propertyName);
		if (cookie) {
            const cookieInstitution = JSON.parse(cookie);
            const localInstitution = SCM.Utilities.LocalStorage.getItem(propertyName);

			if (localInstitution?.entityId !== cookieInstitution.entityId) {
				SCM.Utilities.LocalStorage.setItem(propertyName, cookieInstitution);
				SCM.SeamlessAccess.saveShibbolethID(cookieInstitution.entityId, cookieInstitution.title);
			}
		}
	}

	function getCookieValue(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		if (match) {
			return match[2];
		}
		return '';
    }

    function updateButton() {
        fetchLatestShibbolethData()
            .then(function (persistedInstitutions) {
                if (persistedInstitutions) {
                    return sendSeamlessAccessUpdate(persistedInstitutions);
                }
                throw new Error('No Shibboleth data found');
            })
            .then(updateUIWithSeamlessAccessData)
            .catch(handleSeamlessAccessError);
    }

    function fetchLatestShibbolethData() {
        return SCM.SeamlessAccess.latestShibboleth();
    }

    function sendSeamlessAccessUpdate(persistedInstitutions) {
        return SCM.Ajax.post('/OUP/UpdateSeamlessAccess', persistedInstitutions)
            .sendAsJson()
            .expectJson();
    }

    function updateUIWithSeamlessAccessData(seamlessResultData) {
        updateButtonTextAndLinks(seamlessResultData);
        toggleHeaderButtonVisibility(seamlessResultData);
        toggleChangeInstitutionLinkVisibility(seamlessResultData);
    }

    function updateButtonTextAndLinks(resultData) {
        const $seamlessButtonHeader = $('.seamless-button-header');
        const $seamlessButtonLoginBox = $('.seamless-button-login-box');
        const $seamlessButtonText = $('.seamless-access-text');
        const $changeInstitutionLink = $('.change-institution');

        if (resultData.SeamlessButtonActionType && resultData.SeamlessButtonText) {
            $seamlessButtonLoginBox.attr("data-action-type", resultData.SeamlessButtonActionType)
                .attr("data-entity-id", resultData.SeamlessButtonEntityId);
            $seamlessButtonHeader.attr("data-action-type", resultData.SeamlessButtonActionType)
                .attr("data-entity-id", resultData.SeamlessButtonEntityId);
            $seamlessButtonText.text(resultData.SeamlessButtonText);
            $changeInstitutionLink.attr("data-action-type", resultData.ChangeInstitutionLinkActionType);
        }
    }

    function toggleHeaderButtonVisibility(resultData) {
        const $seamlessButtonHeader = $('.seamless-button-header');
        resultData.ShowHeaderSeamlessButton ? $seamlessButtonHeader.removeClass('hide') : $seamlessButtonHeader.addClass('hide');
    }

    function toggleChangeInstitutionLinkVisibility(resultData) {
        const $changeInstitutionLink = $('.change-institution');
        resultData.ShowChangeInstitutionLink ? $changeInstitutionLink.removeClass('hide') : $changeInstitutionLink.addClass('hide');
    }

    function handleSeamlessAccessError(reason) {
        console.error("Error updating seamless access button:", reason);
    }
})(jQuery);